<template>
  <!-- Iklan -->
  <div class="iklan">
    <div class="content-iklan">
      <div class="row">
        <div class="col-md-6 d-flex flex-column justify-content-center leftside">
          <div class="title-iklan">
            {{ title }}
          </div>
          <span class="text-iklan">{{ description }}</span>
          <button
            class="btn btn-iklan mt-5"
            data-toggle="modal"
            data-target="#modalRegister"
          >
            Coba 7 hari gratis
          </button>
        </div>
        <div class="col-md-6 text-center d-flex align-items-center justify-content-center">
          <img
            class="dashboard-card"
            src="images/dashboard_pic.png"
            alt="dashboard"
          >
        </div>
      </div>
    </div>
  </div>
  <!-- End Iklan -->
</template>
<script>
export default {
  data() {
    return {
      title: 'Zonasea - Platform Perkapalan Terpercaya di Indonesia',
      description: 'Menghubungkan langsung pemilik kapal tug boat, tongkang, tanker, bulk carrier dengan pemilik muatan sawit, batu bara, nikel, solar dan lainnya.'
    }
  },
};
</script>
